import { CommonModule } from '@angular/common';
import { Component, DestroyRef, effect, inject, OnInit, signal, untracked } from '@angular/core';

import { DIALOG_DATA, DialogRef, IconModule } from '@hglobal/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';

import { DialogData, GetPaginationRes, Tab } from '@pp/core/entities';
import { ToCurrencyModule } from '@pp/core/pipes';
import { ShellStore } from '@pp/shell';

import { ChangeType } from './crypto-market';
import { RateInfo, Rates, RatesComponent } from './rates';

enum ExchangeRateScreen {
  rates,
  currencyMarket,
  cryptoMarket,
}
@Component({
  selector: 'pp-exchange-rates',
  imports: [CommonModule, ToCurrencyModule, IconModule, TranslateModule, RatesComponent],
  templateUrl: './exchange-rates.component.html',
  styleUrl: './exchange-rates.component.scss',
})
export class ExchangeRatesComponent implements OnInit {
  readonly #shellStore = inject(ShellStore);
  readonly #translateService = inject(TranslateService);
  dialogRef = inject(DialogRef);
  destroyRef = inject(DestroyRef);
  dialog = inject<DialogData<ExchangeRatesComponent, unknown>>(DIALOG_DATA);

  //cryptoMarket$ = this.#store.select(ShellSelectors.selectCryptoMarket);
  rates = signal<GetPaginationRes<RateInfo>>(null);

  tabs: Tab[] = [
    { index: 0, key: 'exchangeRate.dialog.tab.rates' },
    { index: 1, key: 'exchangeRate.dialog.tab.currencyMarket', disabled: true },
    { index: 2, key: 'exchangeRate.dialog.tab.cryptoMarket', disabled: true },
  ];
  columns = [
    { i18nKey: 'exchangeRate.dialog.tab.name', sortable: false, name: 'name' },
    { i18nKey: 'exchangeRate.dialog.tab.price', sortable: false, name: 'price' },
    { i18nKey: 'exchangeRate.dialog.tab.changeTime', sortable: false, name: 'changeTime' },
    { i18nKey: 'exchangeRate.dialog.tab.marketCap', sortable: false, name: 'marketCap' },
  ];
  index = signal(0);

  exchangeRateScreen = ExchangeRateScreen;
  changeType = ChangeType;
  cryptoMarketFilter$ = of({ sort: 'name' });

  getRatesSuccessEffect = effect(() => {
    const success = this.#shellStore.isGetRatesSuccess();
    if (success) {
      untracked(() => {
        this.rates.set(this.#concatAllCurrencies(this.#shellStore.rates()));
      });
    }
  });

  ngOnInit() {
    // TODO: uncomment back when API part will be ready
    // this.#store.dispatch(ShellActions.getExchangeRates());
    this.#shellStore.getRates();

    this.dialog.title = this.#translateService.instant(this.tabs[this.index()].key);
  }

  setTab(index: number): void {
    this.index.set(index);
    this.dialog.title = this.#translateService.instant(this.tabs[this.index()].key);
  }

  #concatAllCurrencies(rates: GetPaginationRes<Rates>): GetPaginationRes<RateInfo> {
    if (!rates) {
      return null;
    }

    let allRatesInfo: RateInfo[] = [];
    for (const rate of rates.items) allRatesInfo = [...allRatesInfo, ...rate.info];

    return { items: allRatesInfo };
  }
}
